import { Controller, useFormContext } from 'react-hook-form'

import { usAndTerritories } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { updateStateField } from '../../../../../helpers'

export const Country = ({ index }: { index: number }) => {
  const { control, setValue, getValues, clearErrors } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.country`}
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          label="65. Country"
          field={field}
          input={(props) => (
            <Select
              {...props}
              data={usAndTerritories}
              data-qa="65. Country"
              options-data-qa="65. Country option"
              onChange={(value) => {
                updateStateField(
                  `institutionActivitiesInfo.${index as 0}.state`,
                  value,
                  setValue,
                  getValues,
                  clearErrors
                )
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
